import { Component, OnInit } from '@angular/core';
import { IServiceList, IServicePost, ServicesPageService } from '../../services-page.service';

@Component({
  selector: 'app-service-seo',
  templateUrl: './service-seo.component.html',
  styleUrls: ['./service-seo.component.css']
})
export class ServiceSeoComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
  }
}
